// Owner locations are additive app routes. Legacy URLs keep their original
// global views; a shop URL never falls back to another shop's editor.
export const shopSections = [
	'overview',
	'cashiers',
	'tills',
	'tables',
	'drivers',
	'delivery',
	'catalogue',
	'settings',
	'receipt',
	'orders',
	'reports',
] as const;
export type ShopSection = (typeof shopSections)[number];
export type OwnerLocation =
	| { kind: 'business'; section: string }
	| { kind: 'shop'; shopId: string; section: ShopSection }
	| { kind: 'missing' };

const businessSections = new Set([
	'home',
	'shops',
	'cashiers',
	'tills',
	'menu',
	'discounts',
	'orders',
	'reports',
	'shifts',
	'customers',
	'catalogue',
	'settings',
	'help',
	'sign-in-methods',
]);

export function shopPath(shopId: string, section: ShopSection = 'overview'): string {
	return `/owner/shops/${encodeURIComponent(shopId)}/${section}`;
}

export function ownerLocation(path: string): OwnerLocation {
	const clean = path.replace(/\/+$/, '');
	if (clean.startsWith('/owner/shops/')) {
		const bits = clean.slice('/owner/shops/'.length).split('/');
		if (bits.length > 2) return { kind: 'missing' };
		try {
			const shopId = decodeURIComponent(bits[0] ?? '');
			const section = bits[1] || 'overview';
			if (!shopId || shopId.includes('/') || !shopSections.includes(section as ShopSection))
				return { kind: 'missing' };
			return { kind: 'shop', shopId, section: section as ShopSection };
		} catch {
			return { kind: 'missing' };
		}
	}
	const section = clean === '/owner' ? 'home' : clean.slice('/owner/'.length);
	return { kind: 'business', section: businessSections.has(section) ? section : 'home' };
}
